import { React, Component, Container, _ } from 'utils';
import { App, OverlayStore, Creators } from 'model';
import './infobox.less';
import './overlay.less';

class Overlay extends Component {

	static getStores() {
		return [OverlayStore];
	}

	static calculateState(state, props) {
		var { name } = props;

		return {
			visible: OverlayStore.isVisible(name)
		}
	}

	handleClose = () => {
		var { name } = this.props;
		Creators.setOverlayVisible(name, false);
	}

	componentDidMount() {
		this.setup();
	}

	setup() {
		var { visible } = this.state;

		if(visible) {
			$(this.box).addClass('visible');
		} else {
			$(this.box).removeClass('visible');
		}
	}

	componentDidUpdate() {
		this.setup();
	}

	setBoxRef = (box) => {
		this.box = box;
	}

	render() {

		var { title, name, children } = this.props;

		var src = App.resourceUrl('close.svg');
		var css = ['infobox', 'overlay', name];

		return <div ref={ this.setBoxRef } className={ css.join(' ') }>
			<div className="menu">
				<nav className="navbar navbar-expand-lg navbar-light bg-light">
					<span>{ title }</span>
					<div className="items"><img className="close" onClick={ this.handleClose } src={ src } /></div>
				</nav>
			</div>
			<div className="container-fluid">
				<div className="container">

					{ children }

				</div>

			</div>
		</div>
	}
}

export default Container.create(Overlay, { withProps: true });


// WEBPACK FOOTER //
// ./src/modules/components/overlay.js